import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BusinessService } from './business.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.sass']
})
export class BusinessComponent implements OnInit {
  page: number = 1;
  itemsPerPage = 6;
  totalItems : any;

  searchText:any;

  allBusinessList :any;
  allBusinessList_forFilter :any;
  constructor(private spinner:NgxSpinnerService,
              private businessService:BusinessService) { }

  ngOnInit(): void {
    this.getBusiness()
  }

  getBusiness(){
    this.spinner.show();
    let page=1;
    this.businessService.getBusiness(page,this.itemsPerPage).subscribe((result:any)=>{
      console.log("get all usres ",result)
      this.allBusinessList = result.data;
      this.allBusinessList_forFilter = result.data;
      this.totalItems = result.totalPassengers;
      this.spinner.hide()
    })
  }

  gty(page: any){
    this.spinner.show();
    this.businessService.getBusiness(page,this.itemsPerPage).subscribe((result:any)=>{
      this.allBusinessList = result.data;
      this.allBusinessList_forFilter = result.data;
      this.totalItems = result.totalPassengers;
      this.spinner.hide()
    })
  }

  applyFilter(filterValue:any){
    console.log(filterValue);
    let filterValueLower = filterValue.toLowerCase();
         if(filterValue === '' ) {
             this.allBusinessList=this.allBusinessList_forFilter;
         } 
         else {
           this.allBusinessList = this.allBusinessList_forFilter.filter((employee:any) => employee.name.toLowerCase().includes(filterValueLower))
          }
  }



  exportToExcel(){
    /* pass here the table id */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
    /* save to file */  
    XLSX.writeFile(wb, "Business Report.xlsx");
   }

}
